import SecureRoute from "./SecureRoute";
export default SecureRoute;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SecureRoute/index.tsx